import Chip from "@mui/material/Chip";
import { emphasize } from "@mui/material/styles";
import { styled } from "@mui/system";
import { dp } from "ds_legacy/materials/metrics";
import { FONT_SIZE_24 } from "ds_legacy/materials/typography";
import { XCircleIcon } from "lucide-react";
import { MultiValueProps } from "react-select";
import { SelectOption, SelectType } from "./types";

export const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) =>
    typeof prop === "string" && !["isFocused"].includes(prop),
})<Pick<SelectType, "value"> & { isFocused: boolean | undefined }>(
  ({ isFocused, theme }) => ({
    background: isFocused
      ? theme.palette.mode === "light"
        ? emphasize(theme.palette.grey[300], 0.08)
        : emphasize(theme.palette.grey[600], 0.08)
      : undefined,
    margin: theme.spacing(1 / 2, 1 / 4),
  }),
);

export function MultiValue({
  children,
  data,
  isFocused,
  removeProps,
  selectProps: { useShortValue },
}: MultiValueProps<SelectOption>) {
  const displayValue = `${useShortValue ? data.value : data.label}`;
  return (
    <StyledChip
      deleteIcon={
        <div>
          <XCircleIcon
            fontSize={FONT_SIZE_24}
            style={{ height: dp(24), width: dp(24) }}
            {...(removeProps as any)}
          />
        </div>
      }
      isFocused={isFocused}
      label={displayValue || children}
      tabIndex={-1}
      onDelete={removeProps.onClick}
    />
  );
}
